import { decodeHtmlEntities } from 'shared/utils/textFormatters/textFormatters';

import type {
    ProductMetricsDto,
    ProductsResponseDto,
} from '../types/ReportSavingsSummarySchema';

const normalizeProduct = (product: ProductMetricsDto): ProductMetricsDto => ({
    ...product,
    itemName: decodeHtmlEntities(product.itemName),
    brand: decodeHtmlEntities(product.brand ?? ''),
});

export const normalizeSavingsProductsResponse = (
    response: ProductsResponseDto,
): ProductsResponseDto => ({
    ...response,
    items: (response.items ?? []).map(normalizeProduct),
});
